import { PropsWithChildren } from 'react';
import { Box, BoxProps, Flex } from 'reflexbox';
import styled from 'styled-components';

import { ChevronRightIcon } from '@treams/treams-icons';
import { Link } from '@treams/treams-routes';

import { Skeleton } from './Skeleton';

const Container = styled(Flex)`
	border-radius: 8px;
	cursor: pointer;

	&:hover {
		background: ${(props) => props.theme.colors.whiteBlue};

		&:active {
			background: ${(props) => props.theme.colors.lightBlueLight};
		}
	}
`;

const Chevron = styled(Box)`
	width: 24px;

	svg {
		display: block;

		path {
			fill: ${(props) => props.theme.colors.slateBlue};
		}
	}
`;

const Element = styled(Box)`
	border-bottom: 1px solid ${(props) => props.theme.colors.lightBlue};
	:last-child {
		border-bottom: 0;
	}
`;

export const PlainCard = Skeleton(
	function PlainCard(props: PropsWithChildren<BoxProps & { to?: string; onClick?: () => void }>) {
		const container = (
			<Container my={2} mx={-3} px={3} alignItems="center">
				<Box flexShrink={1} flexGrow={1}>
					{props.children}
				</Box>
				<Chevron flexGrow={0} flexShrink={0}>
					<ChevronRightIcon />
				</Chevron>
			</Container>
		);

		return (
			<Element onClick={props.onClick}>
				{props.to ? <Link to={props.to}>{container}</Link> : container}
			</Element>
		);
	},
	function PlainCardSkeleton(props: PropsWithChildren<BoxProps>) {
		return (
			<Element>
				<Flex my={2} alignItems="center">
					<Box flexShrink={1} flexGrow={1}>
						{props.children}
					</Box>
					<Chevron flexGrow={0} flexShrink={0}>
						<ChevronRightIcon />
					</Chevron>
				</Flex>
			</Element>
		);
	},
);
